export const config = {
  // apiurl: 'https://rsmapi.redstarplc.com/api'
  apiurl: 'https://rsmapidev.redstarplc.com/api'
}
